// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__PdfCanvas from "./PdfCanvas.js";
import * as Buhta_cabinet__SignDropdownDesktop from "./SignDropdownDesktop.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function SignFlowDesktop(Props) {
  let code = Props.code;
  let doc = Props.doc;
  const previewUrl = Belt__Belt_Option.getExn(doc.document).preview_url;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "w-20 h-5",
                alt: "buhta",
                src: StaticAsset.src("/static/icons/logo-black-80.svg")
              }),
              JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                className: "ml-10",
                children: "Акт выполненных работ"
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                  className: "text-asphalt",
                  children: "Ждем подписи получателя"
                }),
                className: "px-3 py-0.5 bg-gray-pale rounded-3xl ml-2"
              })
            ],
            className: "flex items-center"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Buhta_cabinet__SignDropdownDesktop.make, {
              title: "Подписать",
              code: code
            }),
            className: "flex items-center"
          })
        ],
        className: "px-6 py-3 flex items-center justify-between border-b border-gray-main bg-white"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Buhta_cabinet__PdfCanvas.make, {
            multi: false,
            hash: doc.hash,
            previewUrl: previewUrl,
            orientation: Belt__Belt_Option.getExn(doc.document).orientation
          }),
          className: "px-6 py-10 overflow-auto w-full"
        }),
        className: "flex flex-1 overflow-auto"
      })
    ],
    className: "h-screen bg-gray-pale flex flex-col"
  });
}

const make = SignFlowDesktop;

export {
  make,
}
/* Buhta_cabinet__PdfCanvas Not a pure module */
